const isObject = obj => obj && typeof obj === 'object';

export const cleanUpNulls = (obj, clearEmpty = true) => {
  const result = cleanUpInner(structuredClone(obj), clearEmpty);

  if (!result) {
    return null;
  }

  const objSize = Object.keys(result).length;
  const hasMin = clearEmpty ? objSize > 0 : objSize >= 0;

  return hasMin ? result : null;
};

const cleanUpInner = (obj, clearEmpty: boolean) => {
  if (!isObject(obj)) {
    return null;
  }

  Object.entries(obj).forEach(([field, value]) => {
    if (isObject(value)) {
      obj[field] = cleanUpInner(value, clearEmpty);
    }

    if (obj[field] === null || obj[field] === undefined) {
      delete obj[field];
    }
  });

  const objSize = Object.keys(obj).length;
  const hasMin = clearEmpty ? objSize > 0 : objSize >= 0;

  return hasMin ? obj : null;
};
